import { render, staticRenderFns } from "./ServiceCenterListTable.vue?vue&type=template&id=536a6b65"
import script from "./ServiceCenterListTable.vue?vue&type=script&lang=js"
export * from "./ServiceCenterListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports